module.exports = __webpack_public_path__ + "static/media/arrive.8fbcb487.png";